<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import { useVersionListStore, VersionActionTypes } from '@/modules/setting/stores/version.list.store.ts'
import VersionDetail from '@/modules/setting/views/VersionDetail.vue'


const router = useRouter()
const versionListStore = useVersionListStore()


const pageTabs = computed(() => {
  return versionListStore.tabs
})
const displayTabContent = computed(() => {
  return versionListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return versionListStore.tableConfig
})
const filter = computed(() => {
  return versionListStore.filter
})
const loading = computed(() => {
  return versionListStore.action_type == VersionActionTypes.FETCHING
})
const page = computed(() => {
  return versionListStore.page
})
const pageSize = computed(() => {
  return versionListStore.pageSize
})
const dataSource = computed(() => {
  return versionListStore.data
})

const handleChangeTab = (tab: any) => {

  versionListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  versionListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  versionListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  versionListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  versionListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  versionListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  versionListStore.newTab({id: item.id, label: `#${item.id} - ${item.version_name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  versionListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await versionListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> versionListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  if(versionListStore.action_type === VersionActionTypes.PENDING) requestFetchAccountList()
})
</script>

<template>
  <dashboard-layout currentRoute="system/version" page-title="Danh sách phiên bản" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="versionListStore.toggleColumnVisibility"
        @on-sort="handleSort"
        :row-action-buttons="[
          { action: handleRowDblClick, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone' }
        ]"
        :buttons="[
                {
                  label: 'Thêm phiên bản',
                  icon: 'gridicons:create',
                  class: 'btn bg-primary bg-hover-primary text-white',
                  action: () => {
                    router.push({ name: 'version-create' })
                  },
                },
                {
                  label: 'Xoá phiên bản đang chọn',
                  icon: 'tabler:trash',
                  class: 'btn btn-secondary bg-hover-secondary',
                  action: () => {},
                },
              ]"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <VersionDetail :id="tab.id" :key="tab.id" action="update"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
